var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8QuotesDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#131f2a",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.991,9.131v0c0,0.459 -0.28,0.882 -0.712,1.036c-3.66,1.305 -9.279,6.104 -9.279,13.833c0,1.328 0.227,2 0.74,2c0.601,0 1.554,-1 4.26,-1c3.289,0 7,2.622 7,7.059c0,3.883 -2.912,7.941 -8,7.941c-4.135,0 -10,-3.083 -10,-12.093c0,-12.478 9.397,-17.774 14.432,-19.811c0.743,-0.3 1.559,0.233 1.559,1.035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.991,9.131v0c0,0.459 -0.28,0.882 -0.712,1.036c-3.66,1.305 -9.279,6.104 -9.279,13.833c0,1.328 0.227,2 0.74,2c0.601,0 1.554,-1 4.26,-1c3.289,0 7,2.622 7,7.059c0,3.883 -2.912,7.941 -8,7.941c-4.135,0 -10,-3.083 -10,-12.093c0,-12.478 9.397,-17.774 14.432,-19.811c0.743,-0.3 1.559,0.233 1.559,1.035z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8QuotesDark);
export default __webpack_public_path__ + "static/media/icons8-quotes-dark.83345cce575f12662f90c758d5dbaf8c.svg";
export { ForwardRef as ReactComponent };